/**
 * Trend Sparkline Component
 * Renders a lightweight SVG sparkline chart showing trend data
 */
export default function TrendSparkline({ data = [], color = 'bg-emerald-500', height = 24 }) {
  if (!data || data.length === 0) {
    return null;
  }

  // Extract values and find min/max for scaling
  const values = data.map(d => typeof d === 'number' ? d : d.value || 0);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;

  // SVG dimensions
  const width = data.length * 8;
  const viewHeight = 24;

  // Calculate points for line chart
  const points = values
    .map((v, i) => {
      const x = i * 8 + 4;
      const y = viewHeight - ((v - min) / range) * 20 - 2;
      return `${x},${y}`;
    })
    .join(' ');

  // Determine color based on trend direction
  const isImproving = values[values.length - 1] < values[0];
  const strokeColor = isImproving ? '#10b981' : '#ef4444';

  // Trend indicator
  const trendIcon = isImproving ? '↓' : '↑';
  const trendColor = isImproving ? 'text-emerald-600' : 'text-red-600';

  return (
    <div className="flex items-center gap-1">
      <svg width={width} height={viewHeight} viewBox={`0 0 ${width} ${viewHeight}`} className="flex-1">
        {/* Grid lines */}
        <line x1="0" y1={viewHeight / 2} x2={width} y2={viewHeight / 2} stroke="#e5e7eb" strokeWidth="0.5" opacity="0.3" />

        {/* Data line */}
        <polyline
          points={points}
          fill="none"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Data points */}
        {values.map((v, i) => {
          const x = i * 8 + 4;
          const y = viewHeight - ((v - min) / range) * 20 - 2;
          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r="1.5"
              fill={strokeColor}
              opacity="0.6"
            />
          );
        })}
      </svg>

      {/* Trend indicator */}
      <span className={`text-xs font-bold ${trendColor} w-4 text-center`}>
        {trendIcon}
      </span>
    </div>
  );
}
